
const formapagtoGridConfig = {
  idField: "idPagto",
  columns: [
    { header: "Código", field: "COD_PAGTO" },    
    { header: "Descrição", field: "descricao" },
    { header: "Taxa", field: "taxa" }, 
    { header: "Ativo", field: "ATIVO",
    formatter: (value) => (value ? "Sim" : "Não")
  }
  ]
};

export default formapagtoGridConfig;